import type { ArticleCardData } from '@metmuseum/types';
import { removeIndexSuffix } from './removeIndexSuffix';

/**
 * @remarks The Perspectives listings treat close looks as article-like content, so they
 * search both indices at once. `sanityType` is a constant_keyword: queryable, but never
 * present in a hit's `_source`, so the index a hit came from is the only thing that tells
 * the two document types apart in the results.
 *
 * ELASTIC_SEARCH_INDICES in ./indices carries the same two mappings, but importing it here
 * would pull the whole site search registry, and with it every card mapping module, into
 * the /perspectives/all client bundle. Two lines of overlap is the cheaper trade.
 */
const SANITY_TYPE_BY_INDEX: Record<string, ArticleCardData['_type']> = {
	articles: 'article',
	'close-looks': 'closeLook',
};

export const PERSPECTIVES_INDICES = Object.keys(SANITY_TYPE_BY_INDEX);

export const perspectivesSanityType = (
	indexName: string,
): ArticleCardData['_type'] =>
	SANITY_TYPE_BY_INDEX[removeIndexSuffix(indexName)];
